import React from 'react';
import { VabysmoJourney } from './pages/VabysmoJourney';
export function App() {
  return <VabysmoJourney data-id="element-0" />;
}